<template>
    <!-- 培训报名页面 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>培训报名</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    培训报名
                </div>
                <div class="inner-wrapper">
                    <!-- 工程经理培训报名表 -->
                    <div class="flex-row" v-if="subjectCode == '1'">
                        <div class="col-35 text-left">
                            <div class="table">
                                1.新疆维吾尔自治区信息系统集成(信息工程)实施工程经理培训报名表下载
                            </div>
                            <div class="email">
                                报名邮箱：{{ applyEmail1 }}
                            </div>
                        </div>
                        <div class="col-20">
                            <Button class="btn" @click="download" style="width: 120px;">点击下载</Button>
                        </div>
                    </div>

                    <!-- 工程经理和能力提高班培训报名表 (同时显示) -->
                    <div class="flex-row" v-if="subjectCode == '2'">
                        <div class="col-35 text-left">
                            <div class="table">
                                2.新疆维吾尔自治区信息系统集成(信息工程)实施工程经理能力提高培训报名表下载
                            </div>
                            <div class="email">
                               继续教育报名邮箱：{{ applyEmail1 }}
                            </div>
                        </div>
                        <div class="col-20">
                            <Button class="btn" @click="download" style="width: 120px;">点击下载</Button>
                        </div>
                    </div>

                    <!-- 运维工程师培训报名表 (subjectCode=3) -->
                    <div class="flex-row" v-if="subjectCode == '3'">
                        <div class="col-35 text-left">
                            <div class="table">
                                3.新疆维吾尔自治区信息系统运行维护服务经理培训报名表下载
                            </div>
                            <div class="email">
                                报名邮箱：{{ applyEmail1 }}
                            </div>
                        </div>
                        <div class="col-20">
                            <Button class="btn" @click="download" style="width: 120px;">点击下载</Button>
                        </div>
                    </div>
                    <div class="flex-row" v-if="false">
                        <div class="col-5 qq text-center">
                            <img src="../assets/QQ.png" alt="">
                        </div>
                        <div class="col-20 text-left" style="font-size: 18px;">
                            QQ：{{ applyQQ1 }}
                        </div>
                        <div class="col-20">
                            <Button class="btn" @click="openQQ" style="width: 120px;">点击联系客服</Button>
                        </div>
                    </div>
                    <!-- <div class="flex-row">
                        <div class="col-5 qq text-center">
                            <img src="../assets/QQ.png" alt="">
                        </div>
                        <div class="col-15 text-left">
                            QQ：{{applyQQ2}}
                        </div>
                        <div class="col-20">
                            <Button class="btn" @click="openQQ2" style="width: 120px;">点击联系客服</Button>
                        </div>
                    </div> -->
                    <div class="sign-request" v-html="content"></div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
export default {
    name: "Sign",
    data() {
        return {
            applyEmail1: "",
            applyEmail2: "",
            applyExcel1: "",
            applyExcel2: "",
            applyQQ1: "",
            content: '',
            applyQQ2: "",
            subjectCode: ''
        }
    },
    mounted() {
        this.getInstance();
        this.setTab();
    },
    watch: {
        '$route': {
            handler(newRoute, oldRoute) {
                // if (oldRoute && newRoute.query.type !== oldRoute.query.type) {

                // }
                this.subjectCode = newRoute.query.subjectCode;
                this.getInstance()
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        getInstance() {
            var that = this;
            this.$http({
                url: that.webhost + 'guide/getTrainingFromWeb?subjectId='+that.subjectCode,
                method: 'GET',
            }).then(({ data }) => {
                if (data && data.code === 0) {
                    that.applyEmail1 = data.data.applyEmail1;
                    that.applyEmail2 = data.data.applyEmail2;
                    that.applyExcel1 = data.data.applyExcel1;
                    that.applyExcel2 = data.data.applyExcel2;
                    that.applyQQ1 = data.data.applyQQ1;
                    that.applyQQ2 = data.data.applyQQ2;
                    that.content = data.data.bmxz;
                } else {
                    that.$toast.error(data.msg)
                }
            })
        },
        download() {
            window.open(this.applyExcel1);
        },
        download2() {
            window.open(this.applyExcel2);
        },
        openQQ() {
            window.open('tencent://message/?uin=' + this.applyQQ1);
        },
        openQQ2() {
            window.open('tencent://message/?uin=' + this.applyQQ2);
        }
    },
    components: {
        Header,
        Footer
    }
}
</script>

<style scoped>
.wrapper {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 90px;
    font-family: "PingFang SC";
}

.title {
    text-align: left;
    font-size: 25px;
    line-height: 72px;
    color: #000;
    border-bottom: solid 2px #ccc;
}

.locationM {
    height: 50px;
    line-height: 50px;
}

.locationM .ivu-breadcrumb {
    font-size: 15px;
    color: #000;
}

.locationM img {
    width: 23px;
    height: 22px;
    margin-right: 5px;
    position: relative;
    top: 3px;
}

.inner-wrapper .flex-row {
    padding: 20px 0;
}

.btn {
    position: relative;
    top: 15px;
}

.table {
    font-size: 22px;
    color: #000;
}

.email {
    font-size: 17px;
    color: #333;
    line-height: 30px;
}

.inner-wrapper .col-15 {
    font-size: 18px;
    line-height: 63px;
    padding-left: 15px;
}

.qq img {
    width: 42px;
    height: 52px;
}

.sign-request {
    padding: 20px 15px;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Sign.vue